import { map } from 'lodash';

import lookerApi from '../services/looker-api';

export const INLINE_QUERY_REQUEST = 'INLINE_QUERY_REQUEST';
export const INLINE_QUERY_SUCCESS = 'INLINE_QUERY_SUCCESS';
export const INLINE_QUERY_ERROR = 'INLINE_QUERY_ERROR';
export const INLINE_QUERY_RESULTS_RESET = 'INLINE_QUERY_RESULTS_RESET';

const requestInlineQuery = (id, filters) => ({
  type: INLINE_QUERY_REQUEST,
  id,
  filters
});

const loadInlineQuery = ({ id, result }) => ({
  type: INLINE_QUERY_SUCCESS,
  id,
  result
});

const errorInlineQuery = error => ({
  type: INLINE_QUERY_ERROR,
  error
});

const resetInlineQueryResults = (id) => ({
  type: INLINE_QUERY_RESULTS_RESET,
  id
});

export const runInlineQuery = (id, queryMeta, filters) => async dispatch => {
  dispatch(requestInlineQuery(id, filters));

  try {
    const filtersObj = Object.assign({}, filters);
    if (id === 'characterVoteEpisodeRank') {
      filtersObj.voteRank = { id: 'voteRank', value: { value: '<6' } };
    }
    const result = await lookerApi.runInlineQuery(id, queryMeta, filtersObj);
    dispatch(loadInlineQuery({ id, result }));
  } catch (error) {
    dispatch(errorInlineQuery(error));
  }
};

export const runInlineQueriesForPage = (
  pageConfig,
  filters = {}
) => async dispatch => {
  const { queries } = pageConfig;
  const queryRequests = map(queries, (queryMeta, id) =>
    dispatch(runInlineQuery(id, queryMeta, filters))
  );

  await Promise.all(queryRequests);
};

export const resetInlineQueryResultsForPage = (
  pageConfig,
) => async dispatch => {
  const { queries } = pageConfig;
  const queryRequests = map(queries, (_, id) => dispatch(resetInlineQueryResults(id)));
  await Promise.all(queryRequests);
};

export const runFormattedInlineQuery = (
  id,
  queryMeta,
  filters
) => async dispatch => {
  dispatch(requestInlineQuery(id, filters));

  try {
    const filtersObj = Object.assign({}, filters);
    if (id === 'characterVoteEpisodeRank') {
      filtersObj.voteRank = { id: 'voteRank', value: { value: '<6' } };
    }
    const result = await lookerApi.runInlineQueryStream(
      id,
      queryMeta,
      filtersObj,
      'json'
    );

    dispatch(loadInlineQuery({ id, result }));
  } catch (error) {
    dispatch(errorInlineQuery(error));
  }
};

export const runFormattedInlineQueriesForPage = (
  pageConfig,
  filters = {}
) => async dispatch => {
  const { queries } = pageConfig;
  const queryRequests = map(queries, (queryMeta, id) =>
    dispatch(runFormattedInlineQuery(id, queryMeta, filters))
  );

  await Promise.all(queryRequests);
};

export const getInlineQuery = () => {};
